import CreateCampaigns from './create-campaigns';

export default CreateCampaigns;
